import {makePostConfirmEmail} from 'main/factories/usecases';

export async function postConfirmEmail(email: string) {
	await makePostConfirmEmail().post({email});

	return email;
}
